module.exports = __webpack_public_path__ + "static/media/error_icon.4d88fd45.svg";